import init from './modules/init';
import $ from 'jquery';

$(() => {
  init();
});



// WEBPACK FOOTER //
// ./app/webroot/javascript/init.js